/**
 * Focus an input/textarea at the start of its value without selecting text
 * (avoids accidental delete-on-type after pencil → edit).
 */
export function focusEditableControlAtStart(
	el: HTMLInputElement | HTMLTextAreaElement | null | undefined,
): void {
	if (!el || el.disabled || el.readOnly) {
		return;
	}
	el.focus({ preventScroll: true });
	try {
		el.setSelectionRange(0, 0);
	} catch {
		// Some input types (e.g. number/email in older engines) reject selection APIs.
	}
}
